import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import { AnimatePresence, motion } from 'framer-motion';

import PageClassesManager from './components/PageClassesManager';
import VerticalNav from './components/VerticalNav';
import Services from './components/Services';
import ContactForm from './components/ContactForm';
import Nosotros from './components/Nosotros';
import Clientes from './components/Clientes';
import WhatsAppButton from './components/WhatsAppButton';
import Termosolares from './components/clientes/Termosolares/Proyectos';

import './App.css';

const variants = {
  initial: {
    opacity: 0,
    x: 50,
    scale: 0.98,
    transition: { duration: 0.5, ease: 'easeInOut' },
  },
  animate: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.8, 0.25, 1], // curva suave tipo easeInOut
      transition: { duration: 0.5, ease: 'easeInOut' },
    },
  },
  exit: {
    opacity: 0,
    x: -50,
    scale: 0.98,
    transition: {
      duration: 0.4,
      ease: [0.42, 0, 1, 1], // ease-in más rápida
      transition: { duration: 0.5, ease: 'easeInOut' },
    },
  },
};

// Componente que detecta subservicio en la URL
const ServiciosWrapper = ({ carouselRef }) => {
  const { serviceIndex } = useParams();
  return <Services carouselRef={carouselRef} serviceIndex={serviceIndex} />;
};

const ClientesWrapper = ({ setIsModalOpen }) => {
  const { clienteId } = useParams();
  return <Clientes clienteId={clienteId} setIsModalOpen={setIsModalOpen} />;
};

const TermosolaresWrapper = ({ setIsModalOpen }) => {
  const { clienteId } = useParams();
  return <Termosolares clienteId={clienteId} setIsModalOpen={setIsModalOpen} />;
};

const isTouchDevice = () => {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const carouselRef = React.useRef(null);

  // Rutas visibles para swipe horizontal
  const sectionMap = {
    '/nosotros': <Nosotros />,
    '/servicios': <ServiciosWrapper carouselRef={carouselRef} />,
    '/clientes': <Clientes />,
    '/contacto': <ContactForm />,
  };

  // Considera / como /nosotros
  const currentPath = location.pathname.startsWith('/servicios/')
    ? '/servicios'
    : location.pathname.startsWith('/clientes/')
      ? '/clientes'
      : location.pathname === '/'
        ? '/nosotros'
        : location.pathname;

  const isSwipeBlocked = (event) => {
    if (isModalOpen) return true;

    const path = event?.event?.composedPath?.() || [];
    return path.some(
      (el) =>
        el.classList?.contains?.('carousel-container') ||
        el.classList?.contains?.('modal-container')
    );
  };

 // AppContent.jsx (o App.js dentro del componente AppContent)

  const handlers = useSwipeable({
    onSwipedLeft: (event) => {
      if (!isTouchDevice() || isSwipeBlocked(event)) return;
      const keys = Object.keys(sectionMap);
      const index = keys.indexOf(currentPath);
      if (index < keys.length - 1) {
  navigate(keys[index + 1]);
       const target = keys[index + 1];
       navigate(target === '/clientes' ? '/clientes/fotovoltaicos' : target);
      }
    },
    onSwipedRight: (event) => {
      if (!isTouchDevice() || isSwipeBlocked(event)) return;
      const keys = Object.keys(sectionMap);
      const index = keys.indexOf(currentPath);
      if (index > 0) {
       navigate(keys[index - 1]);
       const target = keys[index - 1];
       navigate(target === '/clientes' ? '/clientes/fotovoltaicos' : target);
      }
    },
    trackMouse: true,
    trackTouch: true,
    preventDefaultTouchmoveEvent: true,
  });
  

  return (
    <div {...handlers}>
     
      <VerticalNav activeLink={currentPath} navigateToSection={navigate} />

      <AnimatePresence mode="wait">
        <motion.div
          key={
            location.pathname.startsWith('/clientes')
              ? '/clientes'
              : location.pathname.startsWith('/servicios')
                ? '/servicios'
                : location.pathname
          }
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
 

          <Routes location={location}>
            <Route
              path="/clientes/:clienteId"
              element={<ClientesWrapper setIsModalOpen={setIsModalOpen} />}
            />
            <Route path="/clientes" element={<Clientes />} />
            <Route
              path="/clientes/termosolares/:clienteId"
              element={<TermosolaresWrapper setIsModalOpen={setIsModalOpen} />}
            />
            <Route
              path="/clientes/termosolares"
              element={<Termosolares setIsModalOpen={setIsModalOpen} />}
            />

            <Route path="/servicios" element={<Services />} />
            <Route
              path="/servicios/subservicio/:subservice"
              element={<Services />}
            />
            <Route
              path="/servicios/index/:serviceIndex"
              element={<ServiciosWrapper carouselRef={carouselRef} />}
            />
            <Route path="/servicios/:subservice" element={<Services />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/contacto" element={<ContactForm />} />
            <Route path="/" element={<Nosotros />} />
            <Route path="*" element={<div>Página no encontrada</div>} />
            
          </Routes>
        </motion.div>
      </AnimatePresence>

      <WhatsAppButton />
      <div id="modal-root"></div>
    </div>
  );
};

const App = () => (
  <Router>
    <PageClassesManager />
    <AppContent />
  </Router>
);

export default App;
